import { Typography } from '@mui/material'

import { ContentTypeEnum } from '../../shared/types'
import Actions from '../Actions/Actions'
import { Loading } from '../common'
import { Copy, CopyContainer } from '../common/copy'
import { BodyContent, FooterContent, HeaderContent } from '../content'
import DebugJson from '../debug/DebugJson/DebugJson'
import { ItemThumbs } from '../item'
import useScene from './useScene'
import LeadLocked from '../LeadLocked/LeadLocked'
import LeadCopy from '../LeadCopy/LeadCopy'

interface SceneProps {
  sceneId: string
}

const Scene = (props: SceneProps) => {
  const { sceneId } = props
  const { scene, itemsFound, actions, content, loading, error } = useScene({
    sceneId,
  })
  const {
    name: sceneName,
    prefix,
    title,
    subTitle,
    header,
    body,
    footer,
  } = scene || {}
  const { filePath, parentMeta } = content || {}

  if (error) return <div>Error loading Scene: {error}</div>
  if (!scene && !loading) return <div>Scene not found</div>

  const name = sceneName && `${prefix ?? ''}${sceneName}`

  // prettier-ignore
  return (
    <Loading loading={loading} fullscreen message='Loading scene...'>

      {header?.content && <HeaderContent filePath={filePath} parentMeta={parentMeta} contentBlock={header} />}

      {/* <Breadcrumbs /> */}

      {scene?.locked && <LeadLocked />}

      <LeadCopy name={name} title={title} subTitle={subTitle} />

      {itemsFound && <CopyContainer padding={{ right: 'xsmall', left: 'small', top: 'xsmall', bottom: 'small', }}>
          <Typography variant="h4">You found:</Typography>
          <ItemThumbs items={scene?.items} />
        </CopyContainer>}

      

      <Actions actions={actions} />

      {body?.content && <CopyContainer padding='large' topBottom={true}>
        <BodyContent filePath={filePath} parentMeta={parentMeta} contentBlock={body}/> 
      </CopyContainer>}

      {footer?.content && <FooterContent filePath={filePath} parentMeta={parentMeta} contentBlock={footer} />}

      
      <DebugJson json={scene} />
    </Loading>
  )
}

export default Scene
